import { Model } from '../store/types/expediente';
import { MapActions, MapState } from '../store/types/map';
import { useStoreActions, useStoreState } from './store';

export const useExpedienteActions: MapActions<Model> = (mapActions) => useStoreActions((actions) => mapActions(actions.expediente));
export const useExpedienteState: MapState<Model> = (mapState) => useStoreState((state) => mapState(state.expediente));
